// 全部商品分组ID
export const ALL_COMMODITY_GROUP = 1;
// 我可兑换 分组ID
export const CAN_BUY_COMMODITY_GROUP = 2;

export const DEFAULT_COMMODITY_GROUP = [
  {
    gi: ALL_COMMODITY_GROUP,
    gn: '全部商品',
  },
  {
    gi: CAN_BUY_COMMODITY_GROUP,
    gn: '我可兑换',
  },
];

export const DEFAULT_COMMODITY_LIST_IN_GROUP = {
  [ALL_COMMODITY_GROUP]: [],
  [CAN_BUY_COMMODITY_GROUP]: [],
};

// 到账时间-次日到账
export const COMMODITY_ARRIVAL_NEXT_DAY = 2;
// 到账时间-实时到账
export const COMMODITY_ARRIVAL_REAL_TIME = 1;

export const COMMODITY_ARRIVAL_TIME = {
  [COMMODITY_ARRIVAL_NEXT_DAY]: '次日10点前到账',
  [COMMODITY_ARRIVAL_REAL_TIME]: '实时到账',
};

// 现金类型
export const COMMODITY_CASH_TYPE = 1;
// 优惠券类型
export const COMMODITY_COUPON_TYPE = 3;
// 加成卡类型
export const COMMODITY_BONUS_CARD_TYPE = 2;

// 商品到账信息
export const COMMODITY_ARRIVAL_INFO = {
  [COMMODITY_CASH_TYPE]: {
    arrivalText: '我的-余额',
    link: `page:web_view?url=${encodeURIComponent(
      `${window.location.origin}/wallet/balance/summary`
    )}`,
  },
  [COMMODITY_COUPON_TYPE]: {
    arrivalText: '我的-优惠券',
    link:
      'youzan:https%3A%2F%2Fshop90316740.youzan.com%2Fwscump%2Fcoupon%2Fcollection%3Fkdt_id%3D90124572%23%2F',
  },
  [COMMODITY_BONUS_CARD_TYPE]: {
    arrivalText: '我的-权益',
    link: `page:web_view?url=${encodeURIComponent(`${window.location.origin}/rights`)}`,
  },
};

export const WXMALL_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

// 全部
export const ALL_STATUS = 0;
// 订单状态
// 兑换成功
export const ORDER_EXCHANGE_SUCCESS_STATUS = 3;
// 兑换中
export const ORDER_IN_EXCHANGE_STATUS = 1;
// 兑换失败
export const ORDER_EXCHANGE_FAIL_STATUS = 2;

export const ORDER_STATUS = {
  [ORDER_EXCHANGE_SUCCESS_STATUS]: '兑换成功',
  [ORDER_IN_EXCHANGE_STATUS]: '兑换中',
  [ORDER_EXCHANGE_FAIL_STATUS]: '兑换失败',
};

export const ORDER_STATUS_LIST = [
  {
    value: ALL_STATUS,
    label: '全部',
  },
  {
    value: ORDER_EXCHANGE_SUCCESS_STATUS,
    label: ORDER_STATUS[ORDER_EXCHANGE_SUCCESS_STATUS],
  },
  {
    value: ORDER_IN_EXCHANGE_STATUS,
    label: ORDER_STATUS[ORDER_IN_EXCHANGE_STATUS],
  },
  {
    value: ORDER_EXCHANGE_FAIL_STATUS,
    label: ORDER_STATUS[ORDER_EXCHANGE_FAIL_STATUS],
  },
];

// 明细状态
// 明细状态：分为全部、已获取、已消耗、已过期
// 已获取
export const CLOUD_BEAN_ACQUIRED_STATUS = 1;
// 已消耗
export const CLOUD_BEAN_CONSUMED_STATUS = 2;
// 已过期
export const CLOUD_BEAN_EXPIRED_STATUS = 6;
// 已退回
export const CLOUD_BEAN_RETURNED_STATUS = 7;

export const CLOUD_BEAN_STATUS = {
  [ALL_STATUS]: { label: '全部', suffix: '获得', amountPrefix: '+', timePrefix: '' },
  [CLOUD_BEAN_ACQUIRED_STATUS]: {
    label: '已获取',
    suffix: '获得',
    amountPrefix: '+',
    timePrefix: '发放时间：',
  },
  [CLOUD_BEAN_CONSUMED_STATUS]: {
    label: '已消耗',
    suffix: '消耗',
    amountPrefix: '-',
    timePrefix: '消耗时间：',
  },
  [CLOUD_BEAN_EXPIRED_STATUS]: {
    label: '已过期',
    suffix: '',
    amountPrefix: '-',
    timePrefix: '过期时间：',
  },
  [CLOUD_BEAN_RETURNED_STATUS]: { label: '已退回', suffix: '', amountPrefix: '+', timePrefix: '' },
};

export const CLOUD_BEAN_STATUS_LIST = [
  {
    value: ALL_STATUS,
    label: '全部',
  },
  {
    value: CLOUD_BEAN_ACQUIRED_STATUS,
    label: CLOUD_BEAN_STATUS[CLOUD_BEAN_ACQUIRED_STATUS].label,
  },
  {
    value: CLOUD_BEAN_CONSUMED_STATUS,
    label: CLOUD_BEAN_STATUS[CLOUD_BEAN_CONSUMED_STATUS].label,
  },
  {
    value: CLOUD_BEAN_EXPIRED_STATUS,
    label: CLOUD_BEAN_STATUS[CLOUD_BEAN_EXPIRED_STATUS].label,
  },
];

export const EXCHANGE_ORDER_TYPE = 'order';
export const CLOUD_BEAN_RECORD_TYPE = 'record';
export const ORDER_TABS = [
  { value: CLOUD_BEAN_RECORD_TYPE, label: '云豆明细' },
  {
    value: EXCHANGE_ORDER_TYPE,
    label: '兑换记录',
  },
];

export const ORDER_OPTIONS_CONFIG = {
  [CLOUD_BEAN_RECORD_TYPE]: CLOUD_BEAN_STATUS_LIST,
  [EXCHANGE_ORDER_TYPE]: ORDER_STATUS_LIST,
};

export const DEFAULT_ORDER_CHOOSEN_OPTIONS = {
  [CLOUD_BEAN_RECORD_TYPE]: ALL_STATUS,
  [EXCHANGE_ORDER_TYPE]: ALL_STATUS,
};

export const DEFAULT_RECORD_PAGE_SIZE = 3;
export const DEFAULT_ORDER_PAGE_SIZE = 20;

export const DEFAULT_TEXT = '--';
